import {
  GET_LIST_OF_DEMANDS,
  GET_LIST_OF_DEMANDS_SUCCESS,
  GET_LIST_OF_DEMANDS_ERROR,
  GET_TOTAL_DEMANDS,
  GET_TOTAL_DEMANDS_SUCCESS,
  GET_TOTAL_DEMANDS_ERROR,
  GET_ENCRYPT_PURCHASE_DEMANDS,
  GET_ENCRYPT_PURCHASE_DEMANDS_SUCCESS,
  GET_ENCRYPT_PURCHASE_DEMANDS_ERROR
} from './PublicProcurementCourtClaimsSection.actions'

const publicProcurementCourtClaimsState = {
  loading: true,
  error: undefined,
  finalDate: null,
  initialDate: null,
  listOfDemands: null,
  excelData: null,
  totalDemands: null,
  loadingSpinner: false,
  errorEncrypt: undefined
}

/**
 * The Public Procurement Court Claims reducer.
 */
const publicProcurementCourtClaimsReducer = (state = publicProcurementCourtClaimsState, { payload, type }) => {
  switch (type) {
    case GET_TOTAL_DEMANDS: {
      return { ...state, loading: true }
    }
    case GET_TOTAL_DEMANDS_SUCCESS: {
      return {
        ...state,
        loading: false,
        initialDate: payload?.initialDate,
        finalDate: payload?.finalDate,
        totalDemands: payload?.totalDemands
      }
    }
    case GET_TOTAL_DEMANDS_ERROR: {
      return { ...state, loading: false }
    }
    case GET_LIST_OF_DEMANDS: {
      return { ...state, loading: true }
    }
    case GET_LIST_OF_DEMANDS_SUCCESS: {
      return {
        ...state,
        loading: false,
        listOfDemands: payload?.gridData,
        excelData: payload?.excelData
      }
    }
    case GET_LIST_OF_DEMANDS_ERROR: {
      return { ...state, loading: false }
    }

    case GET_ENCRYPT_PURCHASE_DEMANDS: {
      return { ...state, loadingSpinner: true }
    }
    case GET_ENCRYPT_PURCHASE_DEMANDS_SUCCESS: {
      return { ...state, loadingSpinner: false, encrypt: payload.encrypt }
    }
    case GET_ENCRYPT_PURCHASE_DEMANDS_ERROR: {
      return { ...state, loadingSpinner: false, errorEncrypt: payload.error }
    }
    default: {
      return state
    }
  }
}

export default publicProcurementCourtClaimsReducer
